import {
  GET_BANNER_MESSAGES,
  GET_BANNER_MESSAGES_SUCCESS,
  GET_BANNER_MESSAGES_ERROR,
  DELETE_BANNER_MESSAGES,
  DELETE_BANNER_MESSAGES_SUCCESS,
  DELETE_BANNER_MESSAGES_ERROR,
  GET_ADMIN_USER_BANNER_MESSAGES,
  GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
  GET_ADMIN_USER_BANNER_MESSAGES_ERROR,
  DELETE_ADMIN_USER_BANNER_MESSAGES,
  DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
  DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR
} from "./actionTypes"

export const getBannerMessages = () => {
  return {
    type: GET_BANNER_MESSAGES,
  }
}

export const getBannerMessagesSuccess = banner_messages => {
  return {
    type: GET_BANNER_MESSAGES_SUCCESS,
    payload: banner_messages,
  }
}

export const getBannerMessagesError = error => {
  return {
    type: GET_BANNER_MESSAGES_ERROR,
    payload: error,
  }
}

export const getAdminUserBannerMessages = () => {
  return {
    type: GET_ADMIN_USER_BANNER_MESSAGES,
  }
}

export const getAdminUserBannerMessagesSuccess = banner_messages => {
  return {
    type: GET_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
    payload: banner_messages,
  }
}

export const getAdminUserBannerMessagesError = error => {
  return {
    type: GET_ADMIN_USER_BANNER_MESSAGES_ERROR,
    payload: error,
  }
}

export const deleteBannerMessages = banner_messages => {
  return {
    type: DELETE_BANNER_MESSAGES,
    payload: banner_messages
  }
}

export const deleteBannerMessagesSuccess = banner_messages => {
  return {
    type: DELETE_BANNER_MESSAGES_SUCCESS,
    payload: banner_messages,
  }
}

export const deleteBannerMessagesError = error => {
  return {
    type: DELETE_BANNER_MESSAGES_ERROR,
    payload: error,
  }
}


export const deleteAdminUserBannerMessages = adm_banner_messages => {
  return {
    type: DELETE_ADMIN_USER_BANNER_MESSAGES,
    payload: adm_banner_messages
  }
}

export const deleteAdminUserBannerMessagesSuccess = adm_banner_messages => {
  return {
    type: DELETE_ADMIN_USER_BANNER_MESSAGES_SUCCESS,
    payload: adm_banner_messages,
  }
}

export const deleteAdminUserBannerMessagesError = error => {
  return {
    type: DELETE_ADMIN_USER_BANNER_MESSAGES_ERROR,
    payload: error,
  }
}

